import { render, staticRenderFns } from "./MoreMenu.vue?vue&type=template&id=413303ac&"
import script from "./MoreMenu.vue?vue&type=script&lang=js&"
export * from "./MoreMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MoreMenu.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/menus/MoreMenu.vue
// module id = 1653
// module chunks = 1